import { types, applySnapshot } from 'mobx-state-tree';

const Subscription = types
    .model('Subscription', {
        id: types.identifierNumber,
        name: types.optional(types.string, ''),
        url: types.optional(types.string, ''),
        event_types: types.optional(types.array(types.string), []),
        is_active: types.optional(types.boolean, true),
        created_at: types.maybeNull(types.string),
        updated_at: types.maybeNull(types.string),
    })
    .actions((self) => ({
        applyEdit(edited) {
            applySnapshot(self, { ...self, ...edited });
        },
    }));

export default Subscription;
